import { Box, Typography } from "@material-ui/core";
import { useEffect } from "react";
import { useAppSelector } from "../../app/hooks";
import { Buttons } from "./Buttons";
import { Questions } from "./Questions";

export function QuestionPage(props: {
  pageIndex: number,
}) {

  // FIXME 本来はpageIndexを取得するhookを作るべき
  const { 
    pageIndex,
   } = props;

  const cxQuestionPages = useAppSelector(state => {
    return state.inputAnswer.session.cxHttpRes!.data!.cxShopToken!.branch!.cxBrand!.cxQuestionHeaders[0]!.cxQuestionPages;
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pageIndex]);

  // 不正なページIDは救済しない
  if (pageIndex < 0 || pageIndex >= cxQuestionPages.length) {
    return <></>;
  }

  const cxQuestionPage = cxQuestionPages[pageIndex];
  const cxQuestions = cxQuestionPage.cxQuestions;

  return (
    <>
      <Box mx={4} mt={4}>
        <Typography variant='h5'>
          <Box
            fontWeight='fontWeightBold'
            style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
          >
            {cxQuestionPage.title}
          </Box>
        </Typography>
      </Box>
      <Questions pageIndex={pageIndex} cxQuestions={cxQuestions} />
      <Box mx={4} mt={3}>
        <Buttons pageIndex={pageIndex} cxQuestionPages={cxQuestionPages} />
      </Box>
    </>
  );
}
